export enum UploadErrorType {
    SIZE = 'fileSize',
    TYPE = 'accept',
    CLEAR = 'clear'
}
